export default __webpack_public_path__ + "static/media/perfil.d223269b.png";